import React, { useState } from "react";
import mainStyle from "../../dashboard.module.scss";
import { useTheme } from "@mui/material/styles";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, FormControl, Select, MenuItem } from "@mui/material";
import icn_grid_chart from "assets/images/icons/icn_grid_chart.svg";
import { mockNvrData } from "../../const";

const NvrInfo = ({ sortable, nvrs = mockNvrData }) => {
  const theme = useTheme();
  const [selectedNvr, setSelectedNvr] = useState("all");

  const displayData = selectedNvr === "all"
    ? nvrs
    : nvrs.filter((item) => item.name === selectedNvr);

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      className={`main-card-content ${mainStyle["dndObj_card"]} ${
        sortable === true ? mainStyle["dndObj_edit"] : ""
      }`}
    >
      <Box
        className={mainStyle["dndObj_title"]}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img src={icn_grid_chart} alt="nvr_info_icon" />
          <Typography component="span" sx={{ marginLeft: "10px" }}>
            NVR Info
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="caption" color="text.secondary">Show</Typography>
          <FormControl size="small" variant="outlined">
            <Select
              value={selectedNvr}
              onChange={(e) => setSelectedNvr(e.target.value)}
              sx={{
                height: "28px",
                fontSize: "12px",
                borderRadius: "6px",
                "& .MuiSelect-select": { py: 0.5, px: 1 },
              }}
            >
              <MenuItem value="all" sx={{ fontSize: "12px" }}>All</MenuItem>
              {nvrs.map((row) => (
                <MenuItem key={row.name} value={row.name} sx={{ fontSize: "12px" }}>
                  {row.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1, overflow: "hidden", px: 0, pb: 0, mt: 1.5 }}>
        <TableContainer
          sx={{
            maxHeight: "100%",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0, 0, 0, 0.35)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary", pl: 2 }}>NVR</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary" }}>IP Address</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary" }}>Connected CAMs (Online/Offline)</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary", pr: 2 }}>Total Capacity (Used / Total)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayData.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell sx={{ fontSize: "13px", fontWeight: "bold", color: "text.primary", pl: 2 }}>{row.name}</TableCell>
                  <TableCell sx={{ fontSize: "13px", color: "text.secondary" }}>{row.ip}</TableCell>
                  <TableCell sx={{ fontSize: "13px" }}>
                    <Typography component="span" sx={{ color: theme.palette.primary.main, fontWeight: "bold" }}>{row.camsOnline}</Typography>
                    <Typography component="span" sx={{ color: "text.secondary", margin: "0 4px" }}>/</Typography>
                    <Typography component="span" sx={{ color: "text.secondary" }}>{row.camsOffline}</Typography>
                  </TableCell>
                  <TableCell sx={{ fontSize: "13px", pr: 2 }}>
                    <Typography component="span">{row.usedCap}</Typography>
                    <Typography component="span" sx={{ color: "text.secondary", margin: "0 4px" }}>/</Typography>
                    <Typography component="span" sx={{ color: "text.secondary" }}>{row.totalCap}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default NvrInfo;
